:host {
  display: inline-flex;
  height: 24px;
  width: 24px;
  margin: 0 auto;

  .cmm-icon {
    display: block;
    height: auto;
    width: 100%;
  }

  svg {
    display: block;
    fill: var(--wb-grey-60, #9f9f9f);
    fill: currentcolor;
    margin: 0 auto;
    height: 24px;
    width: 24px;
  }
}
